import React from 'react'
import i18n from 'i18next';
import {
  ResultIncreaseIcon,
  ResultDecreaseIcon,
  ResultExactIcon,
  ResultWithinRangeIcon,
  ConfidenceNoRatingIcon,
  ConfidenceLowIcon,
  ConfidenceMediumIcon,
  ConfidenceHighIcon,
} from '@workboard/wobo-ui'

const StartNode = (props) => {
  const { index } = props
  switch (index) {
    case 1:
      return <ResultIncreaseIcon aria-hidden="true" color={'#208ec5'} />
    case 2:
      return <ResultDecreaseIcon aria-hidden="true" color={'#208ec5'} />
    case 3:
      return <ResultExactIcon aria-hidden="true" color={'#208ec5'} />;
    case 4:
      return <ResultWithinRangeIcon aria-hidden="true" color={'#208ec5'} />;
    case 5:
      return <ConfidenceNoRatingIcon aria-hidden="true" />;
    case 6:
      return <ConfidenceLowIcon aria-hidden="true" color={'#D93630'} />;
    case 7:
      return <ConfidenceMediumIcon aria-hidden="true" color={'#FB810F'} />;
    case 8:
      return <ConfidenceHighIcon aria-hidden="true" color={'#77B10B'} />;
    case 9:
      return <img src={`${wbConfig.imageCdnUrl}/images/goal/metric/exceed.png`} style={{width: 16,height:16}} />;
    case 10:
      return <img src={`${wbConfig.imageCdnUrl}/images/goal/metric/fallbelow.png`} style={{width: 16,height:16}} />;
    default:
      return null
  }
}
const resultValueOptions = () => [
    {
      value: 1,
      name: i18n.t('Should increase to'),
      detail: i18n.t('Result value should increase to the specified value'),
      StartNode: <StartNode index={1} />
    },
    {
      value: 2,
      name: i18n.t('Should decrease to'),
      detail: i18n.t('Result value should decrease to the specified value'),
      StartNode: <StartNode index={2} />
    },
    {
      value: 3,
      name: i18n.t('Should be equal to'),
      detail: i18n.t('Result value should be equal to the specified value'),
      StartNode: <StartNode index={3} />
    },
    {
      value: 4,
      name: i18n.t('Should fall within range'),
      detail: i18n.t('Result value should fall within range of the specified value'),
      StartNode: <StartNode index={4} />
    },
    {
      value: 8,
      name: i18n.t('Should not exceed'),
      detail: i18n.t('Result value should not exceed the specified value'),
      StartNode: <StartNode index={9} />
    },
    {
      value: 9,
      name: i18n.t('Should not fall below'),
      detail: i18n.t('Result value should not fall below the specified value'),
      StartNode: <StartNode index={10} />
    },
];
export const getTargetValue = (type=false) => {
    if (type) {
      return resultValueOptions().filter((f) => f.value == 1 || f.value == 2 || f.value == 8|| f.value == 9)
    } else {
      return resultValueOptions()
    }
}

export const confidenceOptions = () => [
  {
    value: 0,
    name: i18n.t('No Rating'),
    StartNode: <StartNode index={5} />
  },
  {
    value: 1,
    name: i18n.t('Low'),
    StartNode: <StartNode index={6} />
  },
  {
    value: 2,
    name: i18n.t('Medium'),
    StartNode: <StartNode index={7} />
  },
  {
    value: 3,
    name: i18n.t('High'),
    StartNode: <StartNode index={8} />
  },
];
export default {
    getTargetValue,
    confidenceOptions,
}